"use strict";

exports.__esModule = true;
exports.Icon = void 0;

var tslib_1 = require("tslib");

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var date_fns_1 = require("date-fns");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var _config_1 = tslib_1.__importDefault(require("../../../config"));

exports.Icon = function (props) {
  switch (props.eventType) {
    case 'phase':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 20,
        height: props.size || 20,
        viewBox: "0 0 24 24"
      }, React.createElement("title", null, props.title), React.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), React.createElement("path", {
        fill: props.theme.inactiveColor,
        d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
      }));

    case 'goal':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: props.size || 20,
        height: props.size || 20
      }, React.createElement("title", null, props.title), React.createElement("path", {
        fill: props.subType && props.subType === 'dropped' ? props.theme.color.danger : props.theme.app.textColor || '#333',
        d: "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0zm0 2.5c.7 0 1.4.1 2.2.2L16 4.2l-2.2-1.5c.7-.2 1.5-.2 2.2-.2zm-5.2 1l4.4 3.2.8.6.7-.5 4.4-3.2c2 .8 3.7 2.1 5.1 3.7l-1.7 5.3-.3.8.7.5 4.5 3.3c-.2 2.2-.8 4.2-1.9 6h-6.4l-.3.8-1.7 5.3c-1 .2-2 .3-3.1.3s-2.2-.1-3.2-.4l-1.7-5.3-.3-.9H4.4c-1.1-1.8-1.7-3.8-1.9-6L7 13.8l.7-.5-.3-.8-1.7-5.3c1.4-1.6 3.1-2.9 5.1-3.7zM16 8.7l-.7.5-5.6 4.1-.7.6.3.8 2.2 6.6.3.8H20.5l.3-.8 2.2-6.6.3-.8-.7-.5L17 9.3l-1-.6zm12 1c.7 1.3 1.1 2.7 1.3 4.2l-2.2-1.6.9-2.6zM4 9.8l.8 2.5-2.2 1.6c.3-1.4.7-2.8 1.4-4.1zm12 2l4.2 3-1.6 4.9h-5.2l-1.6-4.9 4.2-3zm6.9 13.7h2.8c-1 1.1-2.3 2-3.6 2.7l.8-2.7zm-16.6 0H9l.8 2.6c-1.2-.7-2.4-1.6-3.5-2.6z"
      }));

    case 'failed_goal':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 20,
        height: props.size || 20,
        viewBox: "0 0 24 24"
      }, React.createElement("title", null, props.title), React.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), React.createElement("path", {
        fill: props.theme.color.warning,
        d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      }));

    case 'yellow_card':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        id: "card",
        width: props.size || 20,
        height: props.size || 20
      }, React.createElement("title", null, props.title), React.createElement("path", {
        fill: "#ffc600",
        d: "M385.2 512H126.8c-27.5 0-50-22.5-50-50V50c0-27.5 22.5-50 50-50h258.4c27.5 0 50 22.5 50 50v412c0 27.5-22.5 50-50 50z"
      }));

    case 'red_card':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        id: "card",
        width: props.size || 20,
        height: props.size || 20
      }, React.createElement("title", null, props.title), React.createElement("path", {
        fill: "#FF0C00",
        d: "M385.2 512H126.8c-27.5 0-50-22.5-50-50V50c0-27.5 22.5-50 50-50h258.4c27.5 0 50 22.5 50 50v412c0 27.5-22.5 50-50 50z"
      }));

    case 'second_yellow_card':
      return React.createElement("svg", {
        version: "1.1",
        viewBox: "0 0 512 512",
        width: props.size || 20,
        height: props.size || 20
      }, React.createElement("title", null, props.title), React.createElement("g", null, React.createElement("path", {
        fill: "#FF0C00",
        d: "M367.6,512c37.6,0,67.8-30.5,67.8-68.2V68.4c0-16.3-5.7-31.5-15.2-43.3L92.3,487.5   c12.5,15.1,31.1,24.5,52.2,24.5H367.6z"
      }), React.createElement("path", {
        fill: "#FFC700",
        d: "M76.7,68.4v375.4c0,16.6,5.9,31.8,15.6,43.7L420.1,25.2C407.7,9.9,388.9,0,367.6,0H144.4   C106.8,0,76.7,30.8,76.7,68.4z"
      })));

    case 'substitution':
      return React.createElement("svg", {
        version: "1.1",
        id: "Layer_1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 512",
        width: props.size || 20,
        height: props.size || 20
      }, React.createElement("title", null, props.title), React.createElement("path", {
        fill: "#FF0C00",
        d: "M303.1,133.3L151,379.2L0,132.8h303.4L303.1,133.3z"
      }), React.createElement("path", {
        fill: "#63C509",
        d: "M208.9,378.7l152.1-246l151,246.5H208.6L208.9,378.7z"
      }));

    case 'exclusion':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 20,
        height: props.size || 20,
        viewBox: "0 0 24 24"
      }, React.createElement("title", null, props.title), React.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), React.createElement("path", {
        fill: props.theme.color.danger,
        d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
      }));

    case 'timeout':
      return React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.size || 20,
        height: props.size || 20,
        viewBox: "0 0 24 24"
      }, React.createElement("title", null, props.title), React.createElement("path", {
        fill: "#333",
        d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
      }), React.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
      }), React.createElement("path", {
        fill: "#333",
        d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
      }));

    default:
      return null;
  }
};

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n"], ["\n  text-align: center;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var Events = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  &:after {\n    content: '';\n    height: calc(100% - ", ");\n    width: ", ";\n    background: ", ";\n    position: absolute;\n    top: calc(0% + ", ");\n    left: calc(0% + ", ");\n    ", " {\n      left: calc(50% - ", ");\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  &:after {\n    content: '';\n    height: calc(100% - ", ");\n    width: ", ";\n    background: ", ";\n    position: absolute;\n    top: calc(0% + ", ");\n    left: calc(0% + ", ");\n    ", " {\n      left: calc(50% - ", ");\n    }\n  }\n"])), polished_1.rem(70), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, polished_1.rem(35), polished_1.rem(10), utilities_1.mb('s'), polished_1.rem(1));
var EventItem = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n  ", "\n"])), function (_a) {
  var last = _a.last;

  if (last) {
    return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        ", " {\n          &:after {\n            height: 0;\n          }\n        }\n      "], ["\n        ", " {\n          &:after {\n            height: 0;\n          }\n        }\n      "])), Minute);
  }

  return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
}, function (_a) {
  var align = _a.align;

  if (align === 'left') {
    return styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        ", " {\n          flex-direction: row;\n        }\n      "], ["\n        flex-direction: row-reverse;\n        justify-content: flex-end;\n        ", " {\n          flex-direction: row;\n        }\n      "])), utilities_1.mb('s'));
  }

  return styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject([""], [""])));
});
var EventItemPart = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  width: calc(100% - ", ");\n  padding: ", " 0;\n  ", " {\n    width: calc(50% - ", ");\n  }\n"], ["\n  width: calc(100% - ", ");\n  padding: ", " 0;\n  ", " {\n    width: calc(50% - ", ");\n  }\n"])), polished_1.rem(32.5), polished_1.rem(5), utilities_1.mb('s'), polished_1.rem(32.5));
var Spacer = styled_components_1["default"](EventItemPart)(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  ", " {\n    display: block;\n  }\n"])), utilities_1.mb('s'));
var Minute = styled_components_1["default"].div(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n  border: ", " solid ", ";\n  border-width: 0;\n  background: ", ";\n  font-weight: bold;\n  color: ", ";\n  border-radius: 100%;\n  height: ", ";\n  width: ", ";\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin: ", " ", " ", " ", ";\n  padding: ", " ", " ", " ", ";\n  font-size: ", ";\n  z-index: 1;\n  justify-content: center;\n  ", " {\n    margin: ", " ", " ", " ", ";\n    padding: ", " ", " ", " ", ";\n    width: ", ";\n  }\n  ", "\n"], ["\n  text-align: center;\n  border: ", " solid ", ";\n  border-width: 0;\n  background: ", ";\n  font-weight: bold;\n  color: ", ";\n  border-radius: 100%;\n  height: ", ";\n  width: ", ";\n  display: flex;\n  align-items: center;\n  position: relative;\n  margin: ", " ", " ", " ", ";\n  padding: ", " ", " ", " ", ";\n  font-size: ", ";\n  z-index: 1;\n  justify-content: center;\n  ", " {\n    margin: ", " ", " ", " ", ";\n    padding: ", " ", " ", " ", ";\n    width: ", ";\n  }\n  ", "\n"])), polished_1.rem(1), function (_a) {
  var theme = _a.theme;
  return theme.separatorColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.app.bgColor;
}, function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
}, polished_1.rem(35), polished_1.rem(35), polished_1.rem(10), polished_1.rem(15), polished_1.rem(10), polished_1.rem(0), polished_1.rem(10), polished_1.rem(10), polished_1.rem(10), polished_1.rem(0), polished_1.rem(11), utilities_1.mb('s'), polished_1.rem(10), polished_1.rem(15), polished_1.rem(10), polished_1.rem(15), polished_1.rem(10), polished_1.rem(10), polished_1.rem(10), polished_1.rem(10), polished_1.rem(65), function (_a) {
  var phase = _a.phase;

  if (phase) {
    return styled_components_1.css(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n        border-width: 0;\n        visibility: hidden;\n      "], ["\n        border-width: 0;\n        visibility: hidden;\n      "])));
  }

  return styled_components_1.css(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject([""], [""])));
});
var MinuteMask = styled_components_1["default"].div(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject([""], [""])));
var EventItemInfo = styled_components_1["default"](EventItemPart)(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject([""], [""])));
var EventIcon = styled_components_1["default"].div(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_a) {
  var align = _a.align;

  if (align === 'left') {
    return styled_components_1.css(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["\n        flex-direction: row;\n        justify-content: flex-start;\n        ", " {\n          align-items: flex-start;\n          text-align: left;\n        }\n        ", " {\n          justify-content: flex-start;\n          flex-direction: row-reverse;\n          ", " {\n            text-align: right;\n          }\n        }\n      "], ["\n        flex-direction: row;\n        justify-content: flex-start;\n        ", " {\n          align-items: flex-start;\n          text-align: left;\n        }\n        ", " {\n          justify-content: flex-start;\n          flex-direction: row-reverse;\n          ", " {\n            text-align: right;\n          }\n        }\n      "])), Player, utilities_1.mb('s'), Player);
  }

  return styled_components_1.css(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject([""], [""])));
});
var Player = styled_components_1["default"].div(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["\n  padding: 0 ", ";\n  text-align: left;\n"], ["\n  padding: 0 ", ";\n  text-align: left;\n"])), polished_1.rem(15));
var PlayerName = styled_components_1["default"].div(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  font-weight: ", ";\n"], ["\n  font-size: ", ";\n  font-weight: ", ";\n"])), polished_1.rem(12), function (_a) {
  var phase = _a.phase;
  return phase ? 'normal' : 'bold';
});
var EventType = styled_components_1["default"].div(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  ", "\n"], ["\n  font-size: ", ";\n  color: ", ";\n  ", "\n"])), polished_1.rem(11), function (_a) {
  var mobile = _a.mobile,
      theme = _a.theme;
  return mobile ? 'inherit' : '#bbb';
}, function (_a) {
  var theme = _a.theme,
      mobile = _a.mobile;
  return utilities_1.mb('s') + " {\n    display: " + (mobile ? 'none' : 'block') + ";\n  }";
});
var IconWrapper = styled_components_1["default"].div(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject(["\n  min-width: ", ";\n"], ["\n  min-width: ", ";\n"])), polished_1.rem(30));

var TimeLine =
/** @class */
function (_super) {
  tslib_1.__extends(TimeLine, _super);

  function TimeLine() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderEventDetail = function (event, currentTeam, align) {
      var phase = _this.props.eventTypes.find(function (e) {
        return e._id === event.type;
      });

      var team = _this.props.teams.find(function (t) {
        return t._id === event.team;
      });

      return React.createElement(EventItemInfo, null, React.createElement(EventIcon, {
        align: align
      }, React.createElement(IconWrapper, null, React.createElement(exports.Icon, {
        title: phase ? phase.label : '',
        eventType: event.eventType,
        subType: event.type,
        theme: _this.props.theme
      })), React.createElement(Player, null, !!event.player && React.createElement("div", null, React.createElement(PlayerName, null, event.player.name)), event.eventType === 'timeout' && React.createElement(PlayerName, null, "Timeout"), React.createElement(EventType, {
        mobile: true
      }, currentTeam.displayName), !!event.replacement && React.createElement(EventType, null, "Striedaj\u00FAci hr\u00E1\u010D: " + event.replacement.name), !!event.assist && React.createElement(EventType, null, "Asistencia: " + event.assist.name), !!event.type && sportnet_utilities_1.getProp(_this.props.eventTypes.find(function (i) {
        return i._id === event.type;
      }) || {}, ['label']) ? React.createElement(EventType, null, _this.props.eventTypes.find(function (i) {
        return i._id === event.type;
      }).label) : null, !!event.reason && React.createElement(EventType, null, event.reason))));
    };

    _this.getTeam = function (teamSide) {
      return _this.props.teams.find(function (i) {
        return sportnet_utilities_1.getProp(i, ['additionalProperties', 'homeaway'], '') === teamSide;
      });
    };

    _this.getTeamsIds = function () {
      var homeTeam = _this.getTeam('home');

      var homeTeamId = homeTeam ? homeTeam._id : _this.props.teams[0]._id;

      var awayTeam = _this.getTeam('away');

      var awayTeamId = awayTeam ? awayTeam._id : _this.props.teams[1]._id;
      return {
        homeTeamId: homeTeamId,
        awayTeamId: awayTeamId
      };
    };

    _this.getEventTime = function (event) {
      var minutes = "" + Math.ceil(event.eventTime / 60);

      if (_this.props.settings.displaySeconds) {
        minutes = "" + Math.floor(event.eventTime / 60);
        var seconds = String(event.eventTime % 60).padStart(2, '0');
        return minutes + ":" + seconds;
      }

      if (_this.props.settings.overlapTime) {
        var phase = _this.props.settings.phases[event.phase];

        if (phase.endTime && phase.endTime < event.eventTime) {
          var remaind = Math.ceil((event.eventTime - phase.endTime) / 60);
          return React.createElement("div", null, phase.endTime / 60 + "+" + remaind + "'");
        }

        return minutes + "'";
      }

      return minutes + "'";
    };

    _this.renderEventItem = function (teams, event) {
      var currentTeam = teams.find(function (i) {
        return i._id === event.team;
      });

      var homeTeamId = _this.getTeamsIds().homeTeamId;

      return React.createElement(EventItem, {
        align: event.team === homeTeamId ? 'left' : 'right'
      }, event.team === homeTeamId ? _this.renderEventDetail(event, currentTeam, 'left') : React.createElement(Spacer, null), React.createElement(Minute, null, React.createElement(MinuteMask, null), React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, _this.getEventTime(event))), event.team === homeTeamId ? React.createElement(Spacer, null) : _this.renderEventDetail(event, currentTeam, 'right'));
    };

    return _this;
  }

  TimeLine.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        teams = _a.teams,
        protocol = _a.protocol,
        timer = _a.timer,
        phases = _a.phases;
    var playablePhases = phases.filter(function (a) {
      return a.playPhase;
    });
    var PHASES = playablePhases.reduce(function (acc, phase) {
      if (timer && timer[phase._id]) {
        return tslib_1.__spreadArrays(acc, [tslib_1.__assign(tslib_1.__assign({}, phase), {
          startDate: sportnet_utilities_1.getProp(timer[phase._id], ['start', 'date']),
          endDate: sportnet_utilities_1.getProp(timer[phase._id] || {}, ['end', 'date']),
          startTime: sportnet_utilities_1.getProp(timer[phase._id], ['start', 'seconds']) || _this.props.settings.phases[phase._id].startTime,
          endTime: sportnet_utilities_1.getProp(timer[phase._id] || {}, ['end', 'seconds']) || _this.props.settings.phases[phase._id].endTime
        })]);
      }

      return acc;
    }, []);
    var events = (protocol || {
      events: []
    }).events.filter(function (event) {
      return event.eventTime && event.type !== 'goal_shootout';
    }).map(function (event) {
      var timeParts = event.eventTime.split(':');
      var seconds = Number(timeParts[0]) * 60 + Number(timeParts[1]);
      return tslib_1.__assign(tslib_1.__assign({}, event), {
        eventTime: seconds
      });
    });

    if (this.props.settings.reverseTime) {
      events = events.sort(function (a, b) {
        if (a.eventTime > b.eventTime) {
          return -1;
        } else if (a.eventTime < b.eventTime) {
          return 1;
        }

        return 0;
      });
    }

    var eventsByPhase = events.reduce(function (acc, event) {
      var _a;

      return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[event.phase] = tslib_1.__spreadArrays(acc[event.phase] || [], [event]), _a));
    }, PHASES.reduce(function (acc, phase) {
      var _a;

      if (phase && phase.startDate) {
        return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[phase._id] = [], _a));
      }

      return acc;
    }, {}));
    return React.createElement(Wrapper, null, React.createElement(Events, null, Object.keys(eventsByPhase).map(function (phase) {
      var phaseData = PHASES.find(function (i) {
        return i._id === phase;
      });

      if (phaseData) {
        return React.createElement(React.Fragment, {
          key: phase
        }, React.createElement(EventItem, {
          align: "right"
        }, React.createElement(Spacer, null), React.createElement(Minute, {
          phase: true
        }, Math.floor(phaseData.startTime / 60), "'"), React.createElement(EventItemInfo, null, React.createElement(EventIcon, {
          align: "right"
        }, React.createElement(IconWrapper, null, React.createElement(exports.Icon, {
          title: phaseData.label,
          eventType: "phase",
          theme: _this.props.theme
        })), React.createElement(Player, null, React.createElement(PlayerName, {
          phase: true
        }, "Za\u010Diatok - " + phaseData.label), phaseData.startDate && React.createElement(EventType, null, date_fns_1.format(new Date(phaseData.startDate), _config_1["default"].DEFAULT_TIME_FORMAT)))))), eventsByPhase[phase].map(function (event, idx) {
          return React.createElement("div", {
            key: "event_" + idx
          }, _this.renderEventItem(teams, event));
        }), !!phaseData.endDate && React.createElement(EventItem, {
          align: "right"
        }, React.createElement(Spacer, null), React.createElement(Minute, {
          phase: true
        }, Math.floor((phaseData.startTime + phaseData.playTime) / 60), "'"), React.createElement(EventItemInfo, null, React.createElement(EventIcon, {
          align: "right"
        }, React.createElement(IconWrapper, null, React.createElement(exports.Icon, {
          title: phaseData.label,
          eventType: "phase",
          theme: _this.props.theme
        })), React.createElement(Player, null, React.createElement(PlayerName, {
          phase: true
        }, "Koniec - " + phaseData.label), React.createElement(EventType, null, date_fns_1.format(new Date(phaseData.endDate), _config_1["default"].DEFAULT_TIME_FORMAT)))))));
      }

      return null;
    })));
  };

  return TimeLine;
}(React.PureComponent);

exports["default"] = styled_components_1.withTheme(TimeLine);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;